// src/components/TableForm.js
import React from "react";
import { Card, Form, Button } from "react-bootstrap";

function TableForm({
  title,
  onSubmit,
  children,
  buttonLabel,
  buttonVariant = "primary",
  buttonDisabled,
}) {
  return (
    <Card className="action-card h-100">
      <Card.Body>
        <Card.Title className="section-title">{title}</Card.Title>
        <Form onSubmit={onSubmit}>
          {children}
          <div className="text-center">
            <Button
              type="submit"
              size="lg"
              variant={buttonVariant}
              disabled={buttonDisabled}
              className="create-btn mt-4"
            >
              {buttonLabel}
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
}

export default TableForm;
